import {
  Construction,
  Hammer,
  Snowflake,
  Sprout,
  Wrench,
  Truck,
  Users,
  PhoneCall,
  CalendarCheck,
  UserCheck,
  Timer,
  Calculator,
  ReceiptText,
} from "lucide-react";

export const CONTACT = {
  name: "ONE WAY TRANSPORT",
  email: "bobcat@onewaytransport.pl",
  emailLink: "mailto:bobcat@onewaytransport.pl",
  phone: "+48 530 263 805",
  phoneLink: "tel:+48530263805",
};

export const TRUST = [
  { icon: Truck, label: "Nowoczesny sprzęt Bobcat" },
  { icon: Users, label: "Usługi dla firm i klientów prywatnych" },
  { icon: Sprout, label: "Czyszczenie działek i terenów" },
  { icon: PhoneCall, label: "Szybki kontakt i wycena" },
];

export const BENEFITS = [
  { icon: CalendarCheck, label: "Terminowe realizacje" },
  { icon: Truck, label: "Nowoczesny sprzęt Bobcat" },
  { icon: UserCheck, label: "Doświadczony operator" },
  { icon: Timer, label: "Szybkie terminy" },
  { icon: Calculator, label: "Darmowa wycena" },
  { icon: ReceiptText, label: "Faktura VAT" },
];

export const STATS = [
  { value: 10, suffix: "+", label: "Lat doświadczenia" },
  { value: 1000, suffix: "+", label: "Zrealizowanych projektów" },
  { value: 24, suffix: "h+", label: "Szybkie podstawienie sprzętu" },
];

export const IMAGES = {
  heroMain:
    "https://customer-assets.emergentagent.com/job_bobcat-prace/artifacts/jstiuyod_image.png",
  stump:
    "https://customer-assets.emergentagent.com/job_bobcat-prace/artifacts/eyrb2bop_image.png",
  mulchRoad:
    "https://customer-assets.emergentagent.com/job_bobcat-prace/artifacts/bf3d0gw2_image.png",
  terrain:
    "https://customer-assets.emergentagent.com/job_bobcat-prace/artifacts/etd39j0m_image.png",
  bobcatFront:
    "https://customer-assets.emergentagent.com/job_bobcat-prace/artifacts/g58dl1u8_image.png",
  bobcatLift:
    "https://customer-assets.emergentagent.com/job_bobcat-prace/artifacts/rxsat6bg_image.png",
};

export const NAV_LINKS = [
  { id: "start", label: "Start" },
  { id: "o-nas", label: "O nas" },
  { id: "uslugi", label: "Usługi" },
  { id: "realizacje", label: "Realizacje" },
  { id: "kontakt", label: "Kontakt" },
];

const IMG = "https://customer-assets.emergentagent.com/job_bobcat-prace/artifacts";

export const SERVICE_PHOTO_CARDS = [
  {
    img: `${IMG}/eyrb2bop_image.png`,
    label: "Frezowanie",
    title: "Frezowanie pni",
    description:
      "Usuwanie i frezowanie pni oraz przygotowanie terenu do dalszych prac.",
  },
  {
    img: `${IMG}/jstiuyod_image.png`,
    label: "Działki",
    title: "Czyszczenie działek",
    description:
      "Usuwanie korzeni, gałęzi, zarośli i przygotowanie działek pod sprzedaż lub inwestycję.",
  },
  {
    img: `${IMG}/bf3d0gw2_image.png`,
    label: "Mulczowanie",
    title: "Mulczowanie terenu",
    description:
      "Mulczowanie zarośli, samosiejek, krzaków i trudno dostępnych terenów.",
  },
  {
    img: `${IMG}/etd39j0m_image.png`,
    label: "Teren",
    title: "Prace terenowe Bobcat",
    description:
      "Prace porządkowe, przygotowanie terenu i usługi sprzętem Bobcat według potrzeb klienta.",
  },
];

export const SERVICE_EXTRA = [
  {
    icon: Construction,
    title: "Minikoparka Bobcat E19",
    description:
      "Prace ziemne, wykopy, fundamenty, drenaże, odwodnienia oraz niwelacje terenu.",
  },
  {
    icon: Hammer,
    title: "Wyburzenia młotem",
    description: "Wyburzanie młotem oraz rozbijanie betonu.",
  },
  {
    icon: Snowflake,
    title: "Odśnieżanie",
    description:
      "Usuwanie śniegu z terenów utwardzonych, posypywanie solą i piachem.",
  },
  {
    icon: Wrench,
    title: "Inne usługi sprzętem Bobcat",
    description:
      "Różne prace z osprzętem Bobcat w zależności od potrzeb klienta.",
  },
];

export const HERO_VIDEO = {
  src: `${IMG}/dg5c3dg6_Bobcat_mulcher_cutting_bushes_202606251536.mp4`,
  poster: `${IMG}/bf3d0gw2_image.png`,
};

export const SNOW = {
  video: `${IMG}/1bli2rbr_video_202606262150.mp4`,
  poster: `${IMG}/g58dl1u8_image.png`,
};

export const STORY = [
  {
    title: "Czyszczenie działek i terenów",
    text: "Usuwamy zarośla, samosiejki, krzaki, gałęzie i przygotowujemy teren pod sprzedaż, inwestycję lub dalsze prace.",
    img: `${IMG}/etd39j0m_image.png`,
    reverse: false,
  },
  {
    title: "Mulczowanie i prace Bobcat",
    text: "Wykorzystujemy sprzęt Bobcat do mulczowania, frezowania pni oraz oczyszczania trudno dostępnych miejsc.",
    img: `${IMG}/bf3d0gw2_image.png`,
    reverse: true,
  },
];

export const VIDEOS = [
  {
    title: "Mulczowanie i karczowanie",
    desc: "Przykładowe prace mulczerem leśnym Bobcat.",
    thumb: `${IMG}/bf3d0gw2_image.png`,
    url: "https://www.youtube.com/results?search_query=bobcat+mulczer+le%C5%9Bny+mulczowanie",
  },
  {
    title: "Frezowanie pni",
    desc: "Przykładowe frezowanie pni sprzętem Bobcat.",
    thumb: `${IMG}/eyrb2bop_image.png`,
    url: "https://www.youtube.com/results?search_query=bobcat+frezowanie+pni",
  },
  {
    title: "Czyszczenie terenu",
    desc: "Przykładowe oczyszczanie terenu z zarośli.",
    thumb: `${IMG}/etd39j0m_image.png`,
    url: "https://www.youtube.com/results?search_query=bobcat+czyszczenie+dzia%C5%82ki+zaro%C5%9Bla",
  },
];

export const GALLERY = [
  {
    src: `${IMG}/eyrb2bop_image.png`,
    alt: "Bobcat S66 frezowanie pnia",
    label: "Frezowanie pni",
  },
  {
    src: `${IMG}/bf3d0gw2_image.png`,
    alt: "Bobcat S66 czyszczenie działki z zarośli",
    label: "Czyszczenie działki",
  },
  {
    src: `${IMG}/etd39j0m_image.png`,
    alt: "Bobcat S66 prace terenowe przy poboczu",
    label: "Prace terenowe",
  },
  {
    src: `${IMG}/g58dl1u8_image.png`,
    alt: "Bobcat S66 z zamiatarką podczas odśnieżania",
    label: "Odśnieżanie",
    desc: "Usuwanie śniegu z parkingów, dróg wewnętrznych i terenów utwardzonych.",
  },
];
